import { render, staticRenderFns } from "./DiagManagementList.vue?vue&type=template&id=2b00f766&scoped=true&"
import script from "./DiagManagementList.vue?vue&type=script&lang=js&"
export * from "./DiagManagementList.vue?vue&type=script&lang=js&"
import style0 from "./DiagManagementList.vue?vue&type=style&index=0&id=2b00f766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00f766",
  null
  
)

export default component.exports